/* RESPONSIBLE TEAM: team-inbox-management */
import DefaultPredicateManager from 'embercom/lib/common/predicates/default-predicate-manager';

export default DefaultPredicateManager.extend({});
